import { ManualRosteringComponent } from "./manual-rostering/manual-rostering.component";
import { ManualRosteringDeclaration } from "./manual-rostering/manual-rostering.declaration";
import { RosteringOldComponent } from "./rostering-old.component";
import { RoutesDeclaration } from "./routes/routes.declaration";



export const RosteringOldDeclaration = [
    ManualRosteringComponent,
    ManualRosteringDeclaration,
    RoutesDeclaration,
    RosteringOldComponent
];
